module.exports = __webpack_public_path__ + "img/aliaksei-lepik-8qTBHezzF8I-unsplash.b9404f17.jpg";